const publicTypeMap:Record<string, string> = {
    Private: 'Private',
    Invitation: 'By invitation',
    'Walk-in': 'Walk-in',
};

export const addressPublicType = (type: string) => {
    return publicTypeMap[type] || '';
};
